import React, {
  FC, useCallback, useEffect, useState,
} from 'react';

import { AffectedQuestions } from '../../commons/AffectedQuestions';
import { QBackButton } from '../../commons/QBackButton';
import { QConfirmButton } from '../../commons/QConfirmButton';
import { QHeader } from '../../commons/QHeader';

import { Q22Form, Q22Response } from './form';
import { Row } from 'components/base/Row';
import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';
import { CeremonyTypes } from 'modules/budget/data/ceremonyTypeCodes';
import { useBudget } from 'modules/budget/hooks/useBudget';

export const Q22: FC<Record<string, unknown>> = () => {
  const question = BudgetQuestionCodes.Q22;
  const { RespondQuestion } = useBudget();
  const [responseValue, setResponseValue] = useState<CeremonyTypes | null>(null);
  const [autorespond, setautorespond] = useState<boolean>(false);

  const response = useCallback(
    ({ gotoSummary }) => {
      if (responseValue) {
        RespondQuestion({
          gotoSummary,
          question,
          response: { service: responseValue },
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [responseValue],
  );

  const onChange = useCallback((responseData: Q22Response) => {
    setResponseValue(responseData.responseValue);
    setautorespond(responseData.autorespond);
  }, []);

  useEffect(
    () => {
      if (autorespond && responseValue) {
        setautorespond(false);
        response({ gotoSummary: false });
      }
    },
    [autorespond, responseValue, response],
  );

  return (
    <React.Fragment>
      <QHeader question={question} />
      <Q22Form
        question={question}
        onChange={onChange}
      />
      <Row justifyContent="space-between">
        <QBackButton question={question} />
        <Row
          className="f-question-actions"
          justifyContent="flex-end"
        >
          <AffectedQuestions
            question={question}
            response={{ service: responseValue }}
          />
          <QConfirmButton
            disabled={!responseValue}
            question={question}
            onClick={(payload) => response({ gotoSummary: payload?.gotoSummary })}
          />
        </Row>
      </Row>
    </React.Fragment>

  );
};
